<span [matTooltip]="(shouldTranslateUnit() ? (unitTooltipComputed() | transloco) : unitTooltipComputed()) || ''">
    @if (unitQuantity() !== undefined && unitQuantity() !== 1) {
        <span>x {{ unitQuantity() }}&nbsp;</span>
    }
    <span>{{ shouldTranslateUnit() ? (unitTextComputed() | transloco) : unitTextComputed() }}</span>
</span>
